import { render, staticRenderFns } from "./ViewZoneManagement.vue?vue&type=template&id=641a6854&scoped=true"
import script from "./ViewZoneManagement.vue?vue&type=script&lang=js"
export * from "./ViewZoneManagement.vue?vue&type=script&lang=js"
import style0 from "./ViewZoneManagement.vue?vue&type=style&index=0&id=641a6854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a6854",
  null
  
)

export default component.exports